import {Directive, OnDestroy} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {TitleService} from "../shared/title.service";

@Directive({
    selector: 'router-outlet',
    standalone: false
})
export class ActivatedComponentsDirective implements OnDestroy{

  constructor(r: RouterOutlet, titleService: TitleService) {
    r.activateEvents.subscribe(comp => {

    });
  }

  ngOnDestroy () {
    // destroyed.next;
    // destroyed.complete();
  }
}
